
<yoid-spinner [message]="alertMessage" *ngIf="middlewareLoading"></yoid-spinner>

<ng-container *ngIf="alertMessage">
  <app-alert-dialog
    [dismissible]="true">
    {{ alertMessage }}
  </app-alert-dialog> 
</ng-container>
